const initialState = {
  rules: [],
};

const ReminderRules = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REMINDER_RULES':
      return { ...state, rules: action.payload };
    case 'ADD_REMINDER_RULE':
      return { ...state, rules: [...state.rules, action.payload] };
    case 'UPDATE_REMINDER_RULE':
      return {
        ...state,
        rules: state.rules.map((r) => (r.id === action.payload.id ? action.payload : r)),
      };
    case 'REMOVE_REMINDER_RULE':
      return { ...state, rules: state.rules.filter((r) => r.id !== action.id) };
    default:
      return state;
  }
};

export default ReminderRules;
